<div class="reddi-visualisation">
  <div class="header">
    <div class="legend">
      <div class="swatch" style="background: #d80f00"></div>
      <div class="swatch" style="background: #e44b00"></div>
      <div class="swatch" style="background: #f39500"></div>
      <div class="swatch" style="background: #fcc700"></div>
      <div class="swatch" style="background: #c8cc00"></div>
      <div class="swatch" style="background: #aac600"></div>
      <div class="swatch" style="background: #86bf00"></div>
      <div class="swatch" style="background: #2bad00"></div>
      <div class="legend-text">
        {{ 'access to speech sounds → Optimal' | translate }}
      </div>
    </div>
  </div>
  <div class="chart-wrap">
    <canvas #canvas></canvas>
  </div>
</div>
